import { useSelector } from 'react-redux';
import { getCookieByName } from '../utils/functions';

export function useShowMobilePreview() {
  const enableShowMobilePreviewCookie = getCookieByName(
    'showMobilePreview',
    false
  );

  const enableShowMobilePreviewFlow = useSelector(
    (state: any) => state?.workflow?.flowDefiningAttributes?.showMobilePreview
  );

  if (
    enableShowMobilePreviewCookie !== null &&
    enableShowMobilePreviewCookie !== undefined
  ) {
    return enableShowMobilePreviewCookie;
  }
  if (
    enableShowMobilePreviewFlow !== null &&
    enableShowMobilePreviewFlow !== undefined
  ) {
    return enableShowMobilePreviewFlow;
  }
  return '';
}
